import { render, staticRenderFns } from "./DashboardDifferenceCards.vue?vue&type=template&id=3ff2090d&scoped=true"
import script from "./DashboardDifferenceCards.vue?vue&type=script&lang=ts"
export * from "./DashboardDifferenceCards.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff2090d",
  null
  
)

export default component.exports